
import { put, select } from 'redux-saga/effects';

// eslint-disable-next-line import/prefer-default-export
export function* closeAlert({ payload }) {
  if (payload) {
    const onAgreeAction = yield select(state => state.alert.onAgreeAction);
    if (onAgreeAction) {
      yield put(onAgreeAction.asMutable());
    }
  } else {
    const onDismissAction = yield select(state => state.alert.onDismissAction);
    if (onDismissAction) {
      yield put(onDismissAction.asMutable());
    }
  }
}

